import account from './account'
import setting from './setting'
import user from './user'
import cart from './cart'

export default {account, setting,user,cart}